import { useState } from "react";
import axiosInstance from '../../../Config/axiosInstance';
import { Checkbox, Divider, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, MenuItem, Button, Grid, 
    Typography, CircularProgress, Alert, Box, Menu, ListItemIcon, ListItemText, OutlinedInput, Select, FormControl, 
    InputLabel } from '@mui/material';
import { Save, PictureAsPdf, GetApp, Assessment} from '@mui/icons-material';
import './InvoiceProcurementReports.css';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from 'exceljs';
import {saveAs} from "file-saver";
import logoImg from '../../../Images/logo_pmpc.png'


const InvoiceProcurementReports = () => {
    const [invoiceData, setInvoiceData] = useState([]);
    const [fields, setFields] = useState([
        { id: "invoice_number",                   name: "Invoice Number",                   selected: false, value: "all", data: [], loading: false  },
        { id: "project_code",                     name: "Project Code",                     selected: false, value: "all", data: [], loading: false  },
        { id: "contract",                         name: "Contract no.",                     selected: false, value: "all", data: [], loading: false  },
        { id: "purchase_order",                   name: "Purchase Number",                  selected: false, value: "all", data: [], loading: false  },
        { id: "original_invoice",                 name: "Original Invoice",                 selected: false, value: "all", data: [], loading: false  },
        { id: "supplier",                         name: "Supplier",                         selected: false, value: "all", data: [], loading: false  },
        { id: "invoice_without_vat",              name: "Invoice Without VAT",              selected: false, value: "all", data: [], loading: false  },
        { id: "total_invoice_with_vat",           name: "Total Invoice with VAT",           selected: false, value: "all", data: [], loading: false  },
        { id: "credit_note_without_vat",          name: "Credit Note Without VAT",          selected: false, value: "all", data: [], loading: false  },
        { id: "credit_note_with_vat",             name: "Credit Note With VAT",             selected: false, value: "all", data: [], loading: false  },
        { id: "difference_without_vat",           name: "Difference Without VAT",           selected: false, value: "all", data: [], loading: false  },
        { id: "difference_with_vat",              name: "Difference With VAT",              selected: false, value: "all", data: [], loading: false  },
        { id: "invoice_without_vat_system",       name: "Without VAT System",               selected: false, value: "all", data: [], loading: false  },
        { id: "total_invoice_with_vat_system",    name: "With VAT System",                  selected: false, value: "all", data: [], loading: false  },
        { id: "credit_note_without_vat_system",   name: "Credit Note System Without VAT",   selected: false, value: "all", data: [], loading: false  },
        { id: "credit_note_with_vat_system",      name: "Credit Note System With VAT",      selected: false, value: "all", data: [], loading: false  },
        { id: "difference_without_vat_system",    name: "System Difference without VAT",    selected: false, value: "all", data: [], loading: false  },
        { id: "difference_with_vat_system",       name: "System Difference with VAT",       selected: false, value: "all", data: [], loading: false  },
        { id: "invoice_date",                     name: "Invoice Date",                     selected: false, value: "all", data: [], loading: false  },
        { id: "bill_maturity",                    name: "Bill Maturity",                    selected: false, value: "all", data: [], loading: false  },
        { id: "payments_status",                  name: "Status",                           selected: false, value: "all", data: [], loading: false  },
    ]);
    
    const [loading, setLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [error, setError] = useState('');
    const [reportGenerated, setReportGenerated] = useState(false);


    const handleSubmit = async (e) => {
        e.preventDefault();

        const selectedFields = fields.filter(f => f.selected);
        if (selectedFields.length === 0) {
            setError('Please select the fields.');
            setReportGenerated(false);
            setInvoiceData(null);
            return;
        }

        const invalidFields = selectedFields.filter(f => Array.isArray(f.value) && f.value.length === 0);
        if (invalidFields.length > 0) {
            setError('Please select the data filtered inside ALL the fields.');
            setReportGenerated(false);
            setInvoiceData(null);
            return;
        }

        setLoading(true);
        setError('');

        try {
            const payload = {};
            fields
                .filter(f => f.selected && f.value !== "all" && f.value.length > 0)
                .forEach(field => {
                    payload[field.id] = field.value;
                });

            const response = await axiosInstance.post(`/invoice-procurement-report/`, payload)
            console.log(response.data)
            setInvoiceData(response.data)
            setReportGenerated(true)

        } catch (err) {
            setError(err.response?.data?.error || 'Failed to generate report');
            setInvoiceData(null);
            setReportGenerated(false);

        } finally {
            setLoading(false);

        }
    };


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };


    const handleClose = () => {
        setAnchorEl(null);
    };


    const formatNumber = (num) => {
        if (num == null || num === undefined) return '0.00';
        return new Intl.NumberFormat('ro-RO', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    };


    const exportToExcel = async () => {
        if (!invoiceData || !invoiceData.results || invoiceData.results.length === 0) {
            alert('No data to export!');
            return;
        }

        const formatWithCurrency = (value) => {
            if (value === null || value === undefined || value === '') return '-';
            return `${formatNumber(value)} ${invoiceData.system_currency || ''}`.trim();
        };

        const selectedFields = fields.filter(f => f.selected);
        const title = `Invoice Procurement Report - ${invoiceData.report_date}`;

        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet('Report');

        const statusColors = {
            "Paid": "4caf50",
            "Partially paid": "ff9800",
            "Unpaid": "f44336",
        };

        // logo
        try {
            sheet.mergeCells('A1:A4');
            const logo = workbook.addImage({
                buffer: await fetch(logoImg).then(res => res.arrayBuffer()),
                extension: 'png',
            });
            sheet.addImage(logo, {
                tl: { col: 0, row: 0 },
                br: { col: 1, row: 4 }
            });
        } catch (error) {
            console.warn('Logo could not be loaded:', error);
        }

        // titlu
        sheet.mergeCells(`B1:C4`);
        const titleCell = sheet.getCell('B1');
        titleCell.value = title;
        titleCell.font = { size: 14, bold: true };
        titleCell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true
        };

        // metadata
        sheet.getCell("A5").value = "Total Results: " + invoiceData.count;
        sheet.getCell("A6").value = "Date of Report: " + invoiceData.report_date;
        sheet.getCell("A7").value = selectedFields.map(field => {
            const valueLabel = field.value === "all"
                ? "All"
                : Array.isArray(field.value)
                    ? field.data
                        .filter(item => field.value.map(String).includes(String(item.id)))
                        .map(item => item.name)
                        .join(", ")
                    : "-";
            return `${field.name}: ${valueLabel}`;
        }).join(" | ");

        // rand liber dupa titlu
        sheet.insertRow(8, []);

        // header
        const headerRowNumber = 10;
        const headers = selectedFields.map(f => f.name);
        sheet.getRow(headerRowNumber).height = 30;

        const headerRow = sheet.getRow(headerRowNumber);
        headerRow.values = headers;

        // stil pentru header
        headerRow.font = { bold: true };
        headerRow.eachCell((cell) => {
            cell.alignment = {
                vertical: 'middle',
                horizontal: 'center',
                wrapText: true
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFE8E8E8' }
            };
        });

        // date
        invoiceData.results.forEach((row, index) => {
            const dataRowNumber = headerRowNumber + 1 + index;
            const excelRow = sheet.getRow(dataRowNumber);
            excelRow.height = 20;
            excelRow.values = selectedFields.map(field => {
                if (['issued_offer_value', 'contract_value', 'remaining_to_invoice'].includes(field.id)) {
                    return formatWithCurrency(row[field.id]);
                }
                return row[field.id] ?? '-';
            });

            selectedFields.forEach((field, colIndex) => {
                if (field.id === 'payments_status') {
                    const cell = excelRow.getCell(colIndex + 1);
                    const argb = statusColors[row[field.id]];
                    if (argb) {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb }
                        };
                        cell.font = { color: { argb: 'FFFFFFFF' } };
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    }
                }
            });

            excelRow.eachCell((cell) => {
                cell.alignment = {
                    vertical: 'middle',
                    horizontal: 'left',
                    wrapText: false
                };
            });
        });

        // auto-width
        sheet.columns.forEach((column, columnIndex) => {
            let maxLength = 20;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const cellValue = cell.value?.toString() || '';
                maxLength = Math.max(maxLength, cellValue.length);
            });

            if (columnIndex === 0) {
                column.width = 40;
            } else {
                column.width = maxLength + 4;
            }
        });

        // genereaza si salveaza fisierul
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const fileName = `InvoiceReport_${invoiceData.report_date}.xlsx`;
        saveAs(blob, fileName);
    };


    const exportPDF = async () => {
        if (!invoiceData || !invoiceData.results || invoiceData.results.length === 0) {
            alert('No data to export!');
            return;
        }

        const formatWithCurrency = (value) => {
            if (value === null || value === undefined || value === '') return '-';
            return `${formatNumber(value)} ${invoiceData.system_currency || ''}`.trim();
        };

        const selectedFields = fields.filter(f => f.selected);

        // pdf landscape for many columns
        const pdf = new jsPDF("l", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const logo = "/logo_pmpc.png";

        // logo
        pdf.addImage(logo, "PNG", 8, 3, 28, 8);

        // dimensiuni elemente decorative
        const triangleWidth = 20;
        const totalWidth = pdfWidth * 0.25;
        const barWidth = totalWidth - triangleWidth;

        const barHeight = 1.2;
        const secondBarHeight = 2;
        const barTop = 15;
        const barBottom = barTop + barHeight;

        const statusColorsRGB = {
            "Paid": [76, 175, 80],
            "Partially paid": [255, 152, 0],
            "Unpaid": [244, 67, 54],
        };

        // bara scurta
        pdf.setFillColor(23, 52, 88);
        const barOverlap = 1;
        pdf.rect(0, barTop, barWidth + barOverlap, barHeight, "F");

        // triunghi
        pdf.triangle(
            barWidth, barBottom,
            barWidth + triangleWidth, barBottom,
            barWidth, barTop,
            "F"
        );

        // suprapunere
        const overlap = 0.6;
        const headerLongBarTop = barBottom - overlap;

        // bara lunga full-width
        pdf.rect(0, headerLongBarTop, pdfWidth, secondBarHeight, "F");

        const dottedLineY = headerLongBarTop + secondBarHeight;

        // titlu
        pdf.setFontSize(14);
        pdf.setFont("helvetica", "bold");
        pdf.text("Invoice Procurement Report", pdfWidth / 2, dottedLineY + 12, { align: "center" });

        // metadata
        pdf.setFontSize(10);
        pdf.setFont("helvetica", "normal");
        pdf.text("Total Results: " + invoiceData.count, 10, dottedLineY + 20, { align: "left" });
        pdf.text("Date of Report: " + invoiceData.report_date, 10, dottedLineY + 25, { align: "left" });

        // fields used - split across multiple lines if too long
        const fieldsLabel = selectedFields.map(field => {
            const valueLabel = field.value === "all"
                ? "All"
                : Array.isArray(field.value)
                    ? field.data
                        .filter(item => field.value.map(String).includes(String(item.id)))
                        .map(item => item.name)
                        .join(", ")
                    : "-";
            return `${field.name}: ${valueLabel}`;
        }).join(" | ");

        const splitFields = pdf.splitTextToSize(fieldsLabel, pdfWidth - 20);
        pdf.text(splitFields, 10, dottedLineY + 30, { align: "left" });

        const contentTop = dottedLineY + 30 + (splitFields.length * 5);
        let currentY = contentTop;

        // headers dinamice
        const tableHeaders = [selectedFields.map(f => f.name)];

        // date dinamice
        const tableData = invoiceData.results.map(row =>
            selectedFields.map(field => {
                if (['issued_offer_value', 'contract_value', 'remaining_to_invoice'].includes(field.id)) {
                    return formatWithCurrency(row[field.id]);
                }
                const val = row[field.id];
                return val !== null && val !== undefined ? String(val) : '-';
            })
        );

        // latime coloane egala
        const columnCount = selectedFields.length;
        const availableWidth = pdfWidth - 20;
        const colWidth = availableWidth / columnCount;
        const columnStyles = {};
        selectedFields.forEach((_, index) => {
            columnStyles[index] = { cellWidth: colWidth };
        });

        autoTable(pdf, {
            startY: currentY + 5,
            head: tableHeaders,
            body: tableData,
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: "linebreak",
                lineColor: [180, 180, 180],
                lineWidth: 0.25,
                valign: "middle",
                textColor: [0, 0, 0],
            },
            headStyles: {
                fillColor: [232, 232, 232],
                textColor: 0,
                fontStyle: "bold",
                halign: "center",
            },
            columnStyles: columnStyles,
            alternateRowStyles: {
                fillColor: [245, 247, 250]
            },
            margin: { left: 10, right: 10 },
            tableWidth: 'auto',
            theme: 'grid',
            didDrawPage: function (data) {
                if (data.cursor) {
                    currentY = data.cursor.y;
                }
            },
            didParseCell: function (data) {
                if (data.section === 'body') {
                    const field = selectedFields[data.column.index];
                    if (field?.id === 'payments_status') {
                        const color = statusColorsRGB[data.cell.raw];
                        if (color) {
                            data.cell.styles.fillColor = color;
                            data.cell.styles.textColor = [255, 255, 255];
                            data.cell.styles.halign = 'center';
                        }
                    }
                }
            }
        });

        // footer pentru toate paginile
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);

            pdf.setFillColor(23, 52, 88);

            const bottomOffset = 12;
            const longBarTop = pdfHeight - bottomOffset;
            const verticalOverlapFooter = 0.6;

            // bara lunga jos
            pdf.rect(0, longBarTop - verticalOverlapFooter + 0.1, pdfWidth, secondBarHeight, "F");

            // bara scurta + triunghi
            const shortBarTop = longBarTop + secondBarHeight - verticalOverlapFooter;
            const shortBarBottom = shortBarTop + barHeight;

            const barOverlapFooter = 1;
            pdf.rect(0, shortBarTop, barWidth + barOverlapFooter, barHeight, "F");

            pdf.triangle(
                barWidth, shortBarTop,
                barWidth + triangleWidth, shortBarTop,
                barWidth, shortBarBottom,
                "F"
            );

            pdf.setFontSize(7);
            pdf.setFont("helvetica", "normal");
            pdf.text("Generated by PMPC ERP", 10, pdfHeight - 3);
            pdf.text(invoiceData.report_date, pdfWidth - 30, pdfHeight - 3);
            pdf.text(`Page ${i} of ${totalPages}`, pdfWidth / 2, pdfHeight - 3, { align: "center" });
        }

        const fileName = `InvoiceReport_${invoiceData.report_date}.pdf`;
        pdf.save(fileName);
    };


    return (
        <Container maxWidth={false} disableGutters className="inv-proc-report invoice-procurement-report">
            <Container maxWidth={false} disableGutters className="invoice-container">
                <Typography variant="h4" gutterBottom marginTop="20px">
                    Invoice Procurement Report
                </Typography>
                
                <Paper className="filters-paper" sx={{ p: 2 }}>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} md={9}>
                                <Box display="flex" flexWrap="wrap" alignItems="center" gap={2}>
                                    <FormControl 
                                        size="small" 
                                        className="fields-select"
                                        sx={{ minWidth: 180 }}
                                    >
                                        <InputLabel>Fields</InputLabel>
                                        <Select
                                            multiple
                                            value={fields}
                                            onChange={(e) => {
                                                const clickedId = e.target.value[e.target.value.length - 1];

                                                if (clickedId === "all") {
                                                    const allSelected = fields.every(f => f.selected);
                                                    setFields(prev => prev.map(field => ({ 
                                                        ...field, 
                                                        selected: !allSelected,
                                                        value: !allSelected ? field.value : "all",
                                                        data: !allSelected ? field.data : [],
                                                    })));
                                                    setReportGenerated(false);
                                                    return;
                                                }

                                                setFields(prev =>
                                                    prev.map(field =>
                                                        field.id === clickedId
                                                            ? { 
                                                                ...field, 
                                                                selected: !field.selected,
                                                                value: field.selected ? "all" : field.value,
                                                                data: field.selected ? [] : field.data,
                                                            }
                                                            : field
                                                    )
                                                );
                                                setReportGenerated(false);
                                            }}
                                            input={<OutlinedInput label="Fields" />}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        maxHeight: 300,
                                                        width: 250,
                                                        '& .MuiMenuItem-root': {
                                                            fontSize: '0.75rem',
                                                            paddingTop: 0.25,
                                                            paddingBottom: 0.25,
                                                            whiteSpace: 'normal',
                                                            wordBreak: 'break-word',
                                                        },
                                                        '& .MuiCheckbox-root': {
                                                            padding: '2px',
                                                            marginRight: '4px',
                                                        },
                                                    },
                                                },
                                            }}
                                            renderValue={(selected) => {
                                                if (fields.every(f => f.selected)) return "All";
                                                if (fields.filter(f => f.selected).length === 1) return fields.filter(f => f.selected)[0].name ?? "";
                                                return `${fields.filter(f => f.selected).length} fields selected`;
                                            }}
                                            >
                                            <MenuItem value="all">
                                                <Checkbox checked={fields.every(f => f.selected)} />
                                                <ListItemText primary="All" />
                                            </MenuItem>
                                            {fields.map(option => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    <Checkbox checked={option.selected} />
                                                    <ListItemText primary={option.name} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    <Button 
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className="generate-button"
                                        startIcon={loading ? <CircularProgress size={20} /> : <Assessment />}
                                        disabled={loading}
                                    >
                                        {loading ? 'Generating...' : 'Generate Report'}
                                    </Button>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <Grid container spacing={1} justifyContent={{ xs: 'flex-start', md: 'flex-end' }}>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={handleClick}
                                            className="save-button"
                                            startIcon={<Save />}
                                            disabled={!reportGenerated}
                                        >
                                            Save As
                                        </Button>
                                    </Grid>
                                </Grid>

                                <Menu 
                                    anchorEl={anchorEl} 
                                    open={Boolean(anchorEl)} 
                                    onClose={handleClose}
                                >
                                    <MenuItem onClick={() => {
                                        exportPDF();
                                        handleClose();
                                    }}>
                                        <ListItemIcon><PictureAsPdf fontSize="small" /></ListItemIcon>
                                        <ListItemText>Save as PDF</ListItemText>
                                    </MenuItem>
                                    <MenuItem onClick={() =>{
                                        exportToExcel();
                                        handleClose();
                                    }}>
                                        <ListItemIcon><GetApp fontSize="small" /></ListItemIcon>
                                        <ListItemText>Save as Excel</ListItemText>
                                    </MenuItem>
                                </Menu>
                            </Grid>
                        </Grid>

                        {/* FILTERS GRID */}
                        {fields.some(f => f.selected) && (
                            <>
                                <Divider sx={{ width: "100%", paddingTop: 2 }} />

                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2 }}>
                                    {fields.filter(f => f.selected).map(field => (
                                        <FormControl key={field.id} size="small" sx={{ width: 180 }}>
                                            <InputLabel shrink>{field.name}</InputLabel>
                                            <Select
                                                multiple
                                                displayEmpty
                                                value={field.value === "all" ? field.data.map(i => i.id) : field.value}
                                                onChange={() => {}}
                                                onOpen={() => {
                                                    if (field.data.length === 0) {
                                                        setFields(prev =>
                                                            prev.map(f =>
                                                                f.id === field.id ? { ...f, loading: true } : f
                                                            )
                                                        );
                                                        axiosInstance.get(`/invoice-procurement-report-field/?field=${field.id}`)
                                                            .then(res =>
                                                                setFields(prev =>
                                                                    prev.map(f =>
                                                                        f.id === field.id
                                                                            ? { ...f, data: res.data, loading: false }
                                                                            : f
                                                                    )
                                                                )
                                                            )
                                                            .catch(err => {
                                                                console.error(err);
                                                                setFields(prev =>
                                                                    prev.map(f =>
                                                                        f.id === field.id ? { ...f, loading: false } : f
                                                                    )
                                                                );
                                                            });
                                                    }
                                                }}
                                                input={<OutlinedInput notched label={field.name} />}
                                                renderValue={() => {
                                                    if (field.value === "all") return "All";
                                                    if (field.value.length === 0) return "0 selected";
                                                    if (field.value.length === 1) {
                                                        const match = field.data.find(item => String(item.id) === String(field.value[0]));
                                                        return match ? match.name : "1 selected";
                                                    }
                                                    return `${field.value.length} selected`;
                                                }}
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            maxHeight: 300,
                                                            width: 250,
                                                            '& .MuiMenuItem-root': {
                                                                fontSize: '0.75rem',
                                                                paddingTop: 0.25,
                                                                paddingBottom: 0.25,
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word',
                                                            },
                                                            '& .MuiCheckbox-root': {
                                                                padding: '2px',
                                                                marginRight: '4px',
                                                            },
                                                        },
                                                    },
                                                }}
                                            >
                                                {field.loading ? (
                                                    null
                                                ) : (
                                                    <MenuItem value="all" onClick={() => {
                                                        setFields(prev =>
                                                            prev.map(f => {
                                                                if (f.id !== field.id) return f;
                                                                return { ...f, value: f.value === "all" ? [] : "all" };
                                                            })
                                                        );
                                                        setReportGenerated(false);
                                                    }}>
                                                        <Checkbox checked={field.value === "all"} />
                                                        <ListItemText primary="All" />
                                                    </MenuItem>
                                                )}
                                                {field.loading ? (
                                                    <MenuItem disabled>
                                                        <ListItemText primary="Loading..." />
                                                    </MenuItem>
                                                ) : (
                                                    field.data.map(item => (
                                                        <MenuItem key={item.id} value={String(item.id)} onClick={() => {
                                                            setFields(prev =>
                                                                prev.map(f => {
                                                                    if (f.id !== field.id) return f;
                                                                    const current = f.value === "all"
                                                                        ? f.data.map(item => String(item.id))
                                                                        : Array.isArray(f.value)
                                                                            ? f.value.map(String)
                                                                            : [];

                                                                    const updated = current.includes(String(item.id))
                                                                        ? current.filter(v => v !== String(item.id))
                                                                        : [...current, String(item.id)];

                                                                    if (updated.length === f.data.length) return { ...f, value: "all" };
                                                                    return { ...f, value: updated };
                                                                })
                                                            );
                                                            setReportGenerated(false);
                                                        }}>
                                                            <Checkbox checked={field.value === "all" || (Array.isArray(field.value) && field.value.map(String).includes(String(item.id)))} />
                                                            <ListItemText primary={item.name} />
                                                        </MenuItem>
                                                    ))
                                                )}
                                            </Select>
                                        </FormControl>
                                    ))}
                                </Box>
                            </>
                        )}
                        

                        {error && (
                            <Alert severity="error" sx={{ mt: 2 }}>
                                {error}
                            </Alert>
                        )}
                    </form>
                </Paper>

                {invoiceData && reportGenerated && (
                    <>
                        <Box mt={2}>
                            <Typography color="text.secondary">
                                Total results:{' '}
                                <Typography component="span" color="text.primary">
                                    {invoiceData.count}
                                </Typography>
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
                            <Paper sx={{ p: 2 }}>
                                {invoiceData.count > 0 && invoiceData.results?.length > 0 ? (
                                    <TableContainer className="opp-table-container" sx={{ overflowX: 'auto', pb: 1 }}>
                                        <Table size="small" sx={{ tableLayout: 'auto', borderCollapse: 'collapse' }}>
                                            <TableHead>
                                                <TableRow className="table-header">
                                                    {fields.filter(f => f.selected).map(field => (
                                                        <TableCell
                                                            key={field.id}
                                                            className="table-header-cell"
                                                            sx={{ whiteSpace: 'nowrap', px: 3, minWidth: 120 }}
                                                        >
                                                            {field.name}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {invoiceData.results.map((row, index) => (
                                                    <TableRow
                                                        key={index}
                                                        hover
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        {fields.filter(f => f.selected).map(field => {
                                                            let value = row[field.id] ?? '-';

                                                            if (field.id === 'payments_status' && value !== '-') {
                                                                const statusMap = {
                                                                    "Paid": "paid",
                                                                    "Partially paid": "partially-paid",
                                                                    "Unpaid": "unpaid",
                                                                };
                                                                const className = statusMap[value];

                                                                return (
                                                                    <TableCell key={field.id} sx={{ whiteSpace: 'nowrap', px: 3, minWidth: 120, paddingLeft: 1 }}>
                                                                        {className ? (
                                                                            <div className={`invoice-status-badge ${className}`}>
                                                                                {value}
                                                                            </div>
                                                                        ) : (
                                                                            value
                                                                        )}
                                                                    </TableCell>
                                                                );
                                                            }

                                                            return (
                                                                <TableCell key={field.id} sx={{ whiteSpace: 'nowrap', px: 3, minWidth: 120, paddingLeft: 1 }}>
                                                                    {value}
                                                                </TableCell>
                                                            );
                                                        })}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                ) : (
                                    <Alert severity="info">
                                        No invoices found for the selected criteria.
                                    </Alert>
                                )}
                            </Paper>
                        </Box>
                    </>
                )}
            </Container>
            {invoiceData && reportGenerated && (
                <Box className="report-footer">
                    <Typography variant="caption" className="footer-text">
                        Generated on {invoiceData.report_date} | {' '}
                        {fields.filter(f => f.selected).map((field, index, arr) => (
                            <span key={field.id}>
                                {field.name}:{' '}
                                {field.value === "all"
                                    ? "All"
                                    : Array.isArray(field.value)
                                        ? field.data
                                            .filter(item => field.value.map(String).includes(String(item.id)))
                                            .map(item => item.name)
                                            .join(", ")
                                        : "-"
                                }
                                {index < arr.length - 1 ? ' | ' : ''}
                            </span>
                        ))}
                    </Typography>
                </Box>
            )}
        </Container>
    );
};

export default InvoiceProcurementReports;